import
  React
 from 'react';

import
  styled
from 'styled-components';

import {
  Spinner,
  ColorCodes
} from '@vodacom/web-common';


import {
  SPINNER_SIZE
} from 'utils/constants';

const SpinnerOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 99999;
  background-color: #FFF;
  opacity: 0.6;
`;

 const AppSpinner = () => {

  return (

    <React.Fragment>


          <SpinnerOverlay>

            <Spinner
              color={ColorCodes.Red1}
              size={SPINNER_SIZE}
            />

          </SpinnerOverlay>




    </React.Fragment>
  );
}
export default AppSpinner